export default __webpack_public_path__ + "static/affiliate-program-Software-1-3fee6d752b4c4fc2afb832b141e3b434.png";